export default {"src":"/_next/static/media/eligibility.856a8714.svg","height":25,"width":24};